module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.ac6e44ce.otf";